<template>
  <div v-if="isReady" class="panel-body">
    <transition name="fade-expand" mode="out-in">
      <div v-if="!selectedSale" key="history">
        <p class="text-size-20">エントリー履歴</p>
        <transition-group name="expand-card" tag="div">
          <base-table :columns="columns" :data="salesData" key="table">
            <template slot="saleName" slot-scope="props">
              <p>開催期間：{{ formatDate(props.rowData.eventPeriodFrom, props.rowData.eventPeriodTo) }}</p>
              <a @click.stop="handleEditSaleEntry(props.rowData)" class="text--underline font-bold">
                {{ props.rowData.saleName }}
              </a>
              <div class="flexbox justify-between">
                <div class="text-gray">
                  <div>
                    募集期間：{{ formatDate(props.rowData.applicationPeriodFrom, props.rowData.applicationPeriodTo) }}
                  </div>
                  <div>
                    セールID：{{ props.rowData.saleId }}
                  </div>
                </div>
                <div>
                  <button class="btn btn-primary" @click="handleDownload(props.rowData)">
                    ダウンロード
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </template>
            <template slot="memo" slot-scope="props">
              <textarea
                class="form-control"
                v-model="props.rowData.memo"
                @blur="handleSaveMemo(props.rowData)"
              >
              </textarea>
            </template>
            <template slot="actions" slot-scope="props">
              <div class="btn-group">
                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  操作
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" role="menu" @click.stop>
                  <li :class="{'disabled': disabledCancel(props.rowData)}" @click.stop="handleEditSaleEntry(props.rowData)">エントリーを編集する</li>
                  <li :class="{'disabled': disabledCancel(props.rowData)}" @click.stop="openModalConfirm(props.rowData)">エントリーをキャンセルする</li>
                </ul>
              </div>
            </template>
          </base-table>
        </transition-group>
      </div>

      <div v-else key="entry">
        <sale-entry :selectedSale="selectedSale" @backToTop="backToTop"/>
      </div>
    </transition>
    <modal-confirm
      v-if="isShowModalConfirm"
      :message="confirmMessage"
      @confirm="handleCancelSaleEntry"
      @close="closeModalConfirm"
    />
    <modal-alert
      v-if="isShowModalAlert"
      :message="alertMessage"
      :customHide="true"
      :modalWidth="650"
      @close="closeModalAlert"
    />
  </div>
</template>

<script>
import moment from 'moment'
import SaleService from '@/services/salemasterservice'
import BaseTable from './components/BaseTable'
import SaleEntry from './SaleEntry'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTable,
    SaleEntry,
    ModalConfirm,
    ModalAlert
  },
  data () {
    return {
      isReady: false,
      salesData: [],
      columns: [
        {
          title: 'セール',
          name: 'saleName'
        },
        {
          title: 'メモ',
          name: 'memo'
        },
        {
          title: '',
          name: 'actions'
        }
      ],
      cancelSale: null,
      isShowModalConfirm: false,
      confirmMessage: '対象のセールへのエントリーをキャンセルしますが、よろしいですか？',
      isShowModalAlert: false,
      alertMessage: `対象のセールへのエントリーをキャンセルしました。`
    }
  },
  computed: {
    tab () {
      return this.$route.params.tab
    },
    saleId () {
      return this.$route.params.saleId
    },
    selectedSale () {
      return this.salesData.find(i => i.saleId === this.saleId)
    }
  },
  created () {
    this.getSaleHistory()
  },
  methods: {
    async getSaleHistory () {
      this.loader = this.$loading.show()
      await SaleService.getSaleHistory()
        .then((response) => {
          this.salesData = response.data
          this.isReady = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    formatDate (from, to) {
      if (!from || !to) {
        return '・・・'
      }
      const fromDate = moment(from).format('YYYY/M/D HH:mm:ss')
      const toDate = moment(to).format('YYYY/M/D HH:mm:ss')
      return `${fromDate} ～ ${toDate}`
    },
    backToTop () {
      this.$router.replace({name: 'Sale', tab: this.tab, saleId: ''})
    },
    handleEditSaleEntry (sale) {
      const logParams = {
        name: eventCode.sale.history.edit,
        properties: {
          saleId: sale.saleId
        }
      }
      EventService.postTrackLog(logParams)

      this.$router.push({
        name: 'Sale',
        params: { tab: this.tab, saleId: sale.saleId }
      })
    },
    openModalConfirm (sale) {
      if (this.disabledCancel(sale)) {
        return
      }
      this.isShowModalConfirm = true
      this.cancelSale = sale
    },
    closeModalConfirm () {
      $('#confirm-alert').modal('hide')
      this.isShowModalConfirm = false
    },
    openModalAlert () {
      this.isShowModalAlert = true
    },
    closeModalAlert () {
      $('#myModal').modal('hide')
      this.isShowModalAlert = false
    },
    async handleCancelSaleEntry () {
      const logParams = {
        name: eventCode.sale.history.cancel,
        properties: {
          saleId: this.cancelSale.saleId
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      this.closeModalConfirm()
      await SaleService.cancelSaleEntry({ saleId: this.cancelSale.saleId })
        .then((response) => {
          this.salesData = response.data
          this.openModalAlert()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async handleDownload (sale) {
      const logParams = {
        name: eventCode.sale.history.download,
        properties: {
          saleId: sale.saleId
        }
      }
      EventService.postTrackLog(logParams)

      const sellerid = this.$store.getters.getUser.sellerId
      const reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      const filename = `entryList_${sale.saleId}_${sellerid}_${reportTime}.csv`
      await SaleService.downloadSaleEntryProducts({ saleId: sale.saleId }, filename)
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    },
    disabledCancel (sale) {
      const endDate = moment(sale.applicationPeriodTo)
      const now = moment()
      return endDate.isBefore(now)
    },
    async handleSaveMemo (item) {
      const params = {
        saleId: item.saleId,
        memo: item.memo
      }
      await SaleService.saveMemo(params)
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.sale.history.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.dropdown-menu {
  width: max-content;
  left: unset !important;
  right: 0;
  font-size: 14px;
  padding: unset;
}
.dropdown-menu li {
  height: 30px;
  padding: 3px 5px;
  line-height: 24px;
}
.dropdown-menu li:hover {
  cursor: pointer;
  background-color: #deebf7;
}
.dropdown-menu li.disabled {
  background-color: #ccc;
  opacity: 0.6;
}
.dropdown-menu li.disabled:hover {
  cursor: not-allowed;
}
textarea {
  resize: none;
  min-width: 200px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/sale/SaleEntryHistory.vue